import { UserRepository } from "../../../api";
import { Chart } from "chart.js";

export class Report {

	constructor() {
		this.points = [];
		this.colors = [];
		this.labels = [];
	}

	getPoints(points) {
		return points;
	}

	getColor(points) {
		switch(points) {
			case 3: return "rgba(000, 177, 112, .7)";
			case 2: return "rgba(155, 206, 113, .7)";
			case 1: return "rgba(224, 232, 124, .7)";
			case 0: return "rgba(208, 002, 027, .7)";
		}
	}

	compilateArray(obj) {
		const array = Object.keys(obj);

		const toReturn = [];
		
		for (var i = 0; i < array.length; i++) {
			for (var j = 0; j < obj[array[i]].length; j++) {
				toReturn.push(obj[array[i]][j]);
			}
		}
		return toReturn;
	}

	generateReport(id, colors, points, labels, legend) {
		return;
		Chart.defaults.polarArea.animation.animateScale = false;
		Chart.defaults.polarArea.animation.animateRotate = false;
		Chart.defaults.polarArea.animation.startAngle = 0;

		var ctx = document.getElementById(id).getContext('2d');

		let min = -1;
		let max = 3;

		if (id == "general") {
			points = points.map(p => p + 1);
			max = 4;
		}

		var chart = new Chart(ctx, {
			// The type of chart we want to create
			type: 'polarArea',

			// The data for our dataset
			data: {
				datasets: [{
					data: points,
					backgroundColor: colors,
					borderColor: "rgba(255, 255, 255, .7)"
				}],

				// These labels appear in the legend and in the tooltips when hovering different arcs
				labels: labels
			},

			// Configuration options go here
			options: {
				maintainAspectRatio: false,
				responsive: true,
				title: {
					display: false,
					text: 'Custom Chart Title'
				},
				tooltips: {
					enabled: true
				},
				legend: {
					display: false,
					labels: {
						display: false
					}
				},
				scale: {
					ticks: {
						min,
						max,
						stepSize: 1,
						display: false
					}
				}
			}
		});
	}
	
}


// WEBPACK FOOTER //
// src/models/lib/entities/Report.js